export default __webpack_public_path__ + "static/media/H0004.e5758c0a.png";